import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { MediaType } from "./media_types";
export const protobufPackage = "snapchat.content";
export interface VideoDescription {
    mediaQualityType: VideoDescription_MediaQualityType;
    videoPlaybackType: VideoDescription_VideoPlaybackType;
}
export enum VideoDescription_MediaQualityType {
    MEDIA_QUALITY_TYPE_UNKNOWN = 0,
    MEDIA_QUALITY_TYPE_LEVEL_1 = 100,
    MEDIA_QUALITY_TYPE_LEVEL_2 = 200,
    MEDIA_QUALITY_TYPE_LEVEL_3 = 300,
    MEDIA_QUALITY_TYPE_LEVEL_4 = 400,
    MEDIA_QUALITY_TYPE_LEVEL_5 = 500,
    MEDIA_QUALITY_TYPE_LEVEL_6 = 600,
    MEDIA_QUALITY_TYPE_LEVEL_7 = 700,
    MEDIA_QUALITY_TYPE_LEVEL_MAX = 5000,
    MEDIA_QUALITY_TYPE_LEVEL_4_5 = 450,
    MEDIA_QUALITY_TYPE_LEVEL_2_1 = 210,
    MEDIA_QUALITY_TYPE_LEVEL_2_2 = 220,
    MEDIA_QUALITY_TYPE_LEVEL_2_5 = 250,
    MEDIA_QUALITY_TYPE_LEVEL_3_2 = 320,
    MEDIA_QUALITY_TYPE_LEVEL_3_5 = 350,
    MEDIA_QUALITY_TYPE_LEVEL_2_7 = 270,
    MEDIA_QUALITY_TYPE_LEVEL_6_5 = 650,
    UNRECOGNIZED = -1
}
export enum VideoDescription_VideoPlaybackType {
    UNKNOWN_VIDEO_PLAYBACK_TYPE = 0,
    FASTSTART_DISABLED = 1,
    FASTSTART_ENABLED = 2,
    HTTP_STREAMING_DASH = 3,
    HTTP_STREAMING_HLS = 4,
    UNRECOGNIZED = -1
}
export interface MediaReference {
    mediaListId: string;
    claimBehavior: MediaReference_ClaimBehavior;
    url: string;
    contentObject: Uint8Array;
    localContentKey: string;
    localCacheKey: string;
    videoDescription: VideoDescription | undefined;
    mediaType: MediaType;
}
export enum MediaReference_ClaimBehavior {
    CAN_EXTEND_MEDIA_CLAIM = 0,
    DO_NOT_CLAIM = 1,
    UNRECOGNIZED = -1
}
function createBaseVideoDescription(): VideoDescription {
    return { mediaQualityType: 0, videoPlaybackType: 0 };
}
export const VideoDescription: MessageFns<VideoDescription> = {
    encode(message: VideoDescription, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.mediaQualityType !== 0) {
            writer.uint32(16).int32(message.mediaQualityType);
        }
        if (message.videoPlaybackType !== 0) {
            writer.uint32(8).int32(message.videoPlaybackType);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): VideoDescription {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVideoDescription();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.mediaQualityType = reader.int32() as any;
                    continue;
                }
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.videoPlaybackType = reader.int32() as any;
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<VideoDescription>, I>>(base?: I): VideoDescription {
        return VideoDescription.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<VideoDescription>, I>>(object: I): VideoDescription {
        const message = createBaseVideoDescription();
        message.mediaQualityType = object.mediaQualityType ?? 0;
        message.videoPlaybackType = object.videoPlaybackType ?? 0;
        return message;
    },
};
function createBaseMediaReference(): MediaReference {
    return {
        mediaListId: "0",
        claimBehavior: 0,
        url: "",
        contentObject: new Uint8Array(0),
        localContentKey: "",
        localCacheKey: "",
        videoDescription: undefined,
        mediaType: 0,
    };
}
export const MediaReference: MessageFns<MediaReference> = {
    encode(message: MediaReference, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.mediaListId !== "0") {
            writer.uint32(48).int64(message.mediaListId);
        }
        if (message.claimBehavior !== 0) {
            writer.uint32(56).int32(message.claimBehavior);
        }
        if (message.url !== "") {
            writer.uint32(18).string(message.url);
        }
        if (message.contentObject.length !== 0) {
            writer.uint32(26).bytes(message.contentObject);
        }
        if (message.localContentKey !== "") {
            writer.uint32(74).string(message.localContentKey);
        }
        if (message.localCacheKey !== "") {
            writer.uint32(82).string(message.localCacheKey);
        }
        if (message.videoDescription !== undefined) {
            VideoDescription.encode(message.videoDescription, writer.uint32(42).fork()).join();
        }
        if (message.mediaType !== 0) {
            writer.uint32(64).int32(message.mediaType);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): MediaReference {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMediaReference();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 6: {
                    if (tag !== 48) {
                        break;
                    }
                    message.mediaListId = reader.int64().toString();
                    continue;
                }
                case 7: {
                    if (tag !== 56) {
                        break;
                    }
                    message.claimBehavior = reader.int32() as any;
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.url = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.contentObject = reader.bytes();
                    continue;
                }
                case 9: {
                    if (tag !== 74) {
                        break;
                    }
                    message.localContentKey = reader.string();
                    continue;
                }
                case 10: {
                    if (tag !== 82) {
                        break;
                    }
                    message.localCacheKey = reader.string();
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.videoDescription = VideoDescription.decode(reader, reader.uint32());
                    continue;
                }
                case 8: {
                    if (tag !== 64) {
                        break;
                    }
                    message.mediaType = reader.int32() as any;
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<MediaReference>, I>>(base?: I): MediaReference {
        return MediaReference.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<MediaReference>, I>>(object: I): MediaReference {
        const message = createBaseMediaReference();
        message.mediaListId = object.mediaListId ?? "0";
        message.claimBehavior = object.claimBehavior ?? 0;
        message.url = object.url ?? "";
        message.contentObject = object.contentObject ?? new Uint8Array(0);
        message.localContentKey = object.localContentKey ?? "";
        message.localCacheKey = object.localCacheKey ?? "";
        message.videoDescription = (object.videoDescription !== undefined && object.videoDescription !== null)
            ? VideoDescription.fromPartial(object.videoDescription)
            : undefined;
        message.mediaType = object.mediaType ?? 0;
        return message;
    },
};
type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;
export type DeepPartial<T> = T extends Builtin ? T : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>> : T extends {} ? {
    [K in keyof T]?: DeepPartial<T[K]>;
} : Partial<T>;
type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P : P & {
    [K in keyof P]: Exact<P[K], I[K]>;
} & {
    [K in Exclude<keyof I, KeysOfUnion<P>>]: never;
};
export interface MessageFns<T> {
    encode(message: T, writer?: BinaryWriter): BinaryWriter;
    decode(input: BinaryReader | Uint8Array, length?: number): T;
    create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
    fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
